import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import { useLoginContext } from '../Contexts/Login.Context';

const API_URL = import.meta.env.VITE_API_URL;

export const LoginPage = () => {
  const { token, setToken } = useLoginContext();

  if (token) {
    return null;
  }
  const handleLoginSuccess = async (tokenResponse: CredentialResponse) => {
    console.log('Api url');
    console.log(API_URL);
    const token = await fetch(`${API_URL}/auth/google`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: tokenResponse.credential }),
    })
      .then(response => response.json())
      .then(data => {
        return data.token;
      });

    setToken(token);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100svh',
        width: '100svw',
      }}
    >
      <GoogleLogin onSuccess={handleLoginSuccess} onError={() => console.log('Login Failed')} />
    </div>
  );
};
